import { IconPropsType } from '..';

export const TelegramIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12284_183255)">
      <path
        d="M9.5 18C14.4706 18 18.5 13.9706 18.5 9C18.5 4.02944 14.4706 0 9.5 0C4.52944 0 0.5 4.02944 0.5 9C0.5 13.9706 4.52944 18 9.5 18Z"
        fill="url(#paint0_linear_12284_183255)"
      />
      <path
        d="M6.59229 9.65788L7.66006 12.6133C7.66006 12.6133 7.79356 12.8899 7.93651 12.8899C8.07946 12.8899 10.2056 10.678 10.2056 10.678L12.57 6.11121L6.63039 8.89498L6.59229 9.65788Z"
        fill="#C8DAEA"
      />
      <path
        d="M8.00788 10.4158L7.80291 12.5943C7.80291 12.5943 7.71711 13.2618 8.38446 12.5943C9.05181 11.9268 9.69058 11.4121 9.69058 11.4121"
        fill="#A9C6D8"
      />
      <path
        d="M6.61141 9.76334L4.41496 9.04769C4.41496 9.04769 4.15246 8.94119 4.23698 8.69969C4.25438 8.64989 4.28948 8.60752 4.39448 8.53469C4.88116 8.19547 13.4024 5.13269 13.4024 5.13269C13.4024 5.13269 13.643 5.05162 13.7849 5.10554C13.82 5.11641 13.8516 5.13641 13.8765 5.16349C13.9013 5.19057 13.9185 5.22376 13.9263 5.25967C13.9416 5.32309 13.9481 5.38835 13.9454 5.45354C13.9447 5.50994 13.9379 5.56222 13.9327 5.64419C13.8808 6.48157 12.3277 12.7312 12.3277 12.7312C12.3277 12.7312 12.2348 13.0969 11.9018 13.1094C11.82 13.112 11.7385 13.0982 11.6622 13.0686C11.5858 13.0391 11.5162 12.9945 11.4575 12.9375C10.8041 12.3755 8.54603 10.858 8.04706 10.5242C8.0358 10.5165 8.02632 10.5066 8.01926 10.4949C8.0122 10.4833 8.00771 10.4702 8.00611 10.4567C7.99913 10.4215 8.03738 10.378 8.03738 10.378C8.03738 10.378 11.9693 6.88297 12.074 6.51607C12.0821 6.48764 12.0515 6.47362 12.0104 6.48607C11.7492 6.58214 7.22206 9.44107 6.72241 9.75659C6.68644 9.76747 6.64843 9.76979 6.61141 9.76334Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_12284_183255"
        x1="9.5"
        y1="18"
        x2="9.5"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D93D2" />
        <stop
          offset="1"
          stopColor="#38B0E3"
        />
      </linearGradient>
      <clipPath id="clip0_12284_183255">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
